module.exports = __webpack_public_path__ + "img/rss-02.611d25e2.svg";